// extracted by mini-css-extract-plugin
export default {"fs":"_00bb8f2164 e8e6bdc8c1"};